// extracted by mini-css-extract-plugin
module.exports = {"calendarContainer":"ClockData_calendarContainer__1gGu-","calendarButtons":"ClockData_calendarButtons__1XN7S"};